export const profile = {
  myProfile: {
    menu: {
      coins: "コイン",
      points: "ポイントについて",
      gallery: "ギャラリー",
      videoCall: "ビデオ通話許可",
      contact: "お問い合わせ",
    },
  },
  user: {
    call: "通話する",
    instantCallBanner: "今すぐ通話可能！",
    watchLive: "ライブ配信を視聴",
    chargeAndWatch: "ポイントをチャージして視聴",
    livePointRate: (args: { point: string | number }) => `${args.point}/分`,
    insufficientPoint: "ポイントが足りません",
    chat: "チャット",
    photos: "写真",
    noPhotos: "写真はありません",
    photoPrev: "前の写真",
    photoNext: "次の写真",
    menu: "メニュー",
    favorite: "いいね",
    bookmark: "お気に入り",
    details: "プロフィール詳細",
    ageUnit: "歳",
    toggleSheet: "シートを切り替え",
    cupBadge: {
      label: (args: { letter: string | number }) => `${args.letter}カップ`,
    },
    videoCall: "ビデオ通話",
    voiceCall: "音声通話",
    lastLoginOver24h: "24時間以上前",
    identityVerified: "本人確認済み",
  },
  similarUsersSection: {
    title: "似ているお相手",
  },
} as const;
